import type { LayerSpecification } from "maplibre-gl";

import { SOURCES } from "../sources";
import { LAYERS } from "./constants";

export const trails: LayerSpecification = {
  id: LAYERS.TRAILS,
  type: "line",
  source: SOURCES.TRAILS,
  layout: {
    "line-cap": "round",
    "line-join": "round",
  },
  paint: {
    "line-width": 1,
    "line-gradient": [
      "interpolate",
      ["linear"],
      ["-", 1, ["line-progress"]],
      0.0,
      "rgba(186, 230, 253, 0.7)", // fully visible
      0.9,
      "rgba(99, 101, 241, 0.4)",
      1.0,
      "rgba(192, 38, 211, 0.0)", // fully transparent
    ],
  },
};
